import type { OrganizationConcurrencyView } from '@/lib/api/generated/model';

export interface WorkspaceAtLimit {
  workspaceId: string;
  name: string;
  running: number;
  limit: number;
}

/** The whole installation at once, for the console Overview (spec 116 US3). */
export interface InstallationLoad {
  running: number;
  queued: number;
  ceiling: number;
  /** Workspaces whose running count has reached their enforced limit, by name. */
  atLimit: WorkspaceAtLimit[];
}

/**
 * Sums the organization concurrency read (service spec 110) into one reading.
 *
 * "At their limit" is `running >= limit` — the test the queue reason uses — so a
 * workspace whose limit was lowered under runs already going counts too. Order is
 * the read's own (by name).
 */
export function installationLoad(
  view: OrganizationConcurrencyView,
): InstallationLoad {
  let running = 0;
  let queued = 0;
  const atLimit: WorkspaceAtLimit[] = [];
  for (const row of view.workspaces) {
    running += row.running;
    queued += row.queued;
    if (row.running >= row.limit) {
      atLimit.push({
        workspaceId: row.workspace_id,
        name: row.name,
        running: row.running,
        limit: row.limit,
      });
    }
  }
  return { running, queued, ceiling: view.ceiling, atLimit };
}
